import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Group, Menu, UnstyledButton } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

import classes from './LanguagePicker.module.css';
import { languages } from '@/contants/languages';

type LanguagePickerProps = {
  type: 'collapsed' | 'expanded';
};

const LanguagePicker = ({ type }: LanguagePickerProps) => {
  const [selected, setSelected] = useState(languages[0]);
  const { i18n } = useTranslation();

  useEffect(() => {
    const currentLanguage = languages.find(lang => lang.shortCode === i18n.language);
    if (currentLanguage) {
      setSelected(currentLanguage);
    }
  }, [i18n.language]);

  const changeLanguage = (item: { label: string; shortCode: string; isoCode: string; countryCode: string; }) => {
    i18n.changeLanguage(item.shortCode);
    setSelected(item);
  }

  const items = languages.map((item) => (
    <Menu.Item
      leftSection={
        <div className={classes.menuFlag}>
          <span className={`flag flag-xs flag-country-${item.countryCode}`} />
        </div>
      }
      onClick={() => changeLanguage(item)}
      key={item.label}
    >
      {item.label}
    </Menu.Item>
  ));

  return (
    <Menu
      radius="sm"
      withinPortal
      width={200}
    >
      <Menu.Target>
        <UnstyledButton className={classes.control}>
          <Group gap="xs">
            <div className={classes.flag}>
              <span className={`flag flag-xs flag-country-${selected.countryCode}`} />
            </div>
            {type === 'expanded' && (
              <span className={classes.label}>{selected.label}</span>
            )}
          </Group>
          {type === 'expanded' && (
            <IconChevronDown
              size="1rem"
              className={classes.icon}
              stroke={1.5}
            />
          )}
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>{items}</Menu.Dropdown>
    </Menu>
  );
};

export default LanguagePicker;